// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3d8zn","gfeWrapper":"CalendarEvent_gfeWrapper__3rO4t"};